
import { defineComponent } from 'vue'
import TableMixins from './TableMixins'

export default defineComponent({
  mixins: [TableMixins],
  props: {
    width: {
      type: Number,
      default: 95
    }
  }
})
